import WebsiteHeader from "./website-components/WebsiteHeader";
import WebsiteFooter from "./website-components/WebsiteFooter";
import { Link } from "react-router-dom";

const ContactUs = () => {
  return (
    <main className="dark:bg-[#F8FAFC] dark:text-black">
      {/* page header */}
      <WebsiteHeader />

      {/* Contact Section */}
      <section className="flex-1 flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl w-full bg-white dark:bg-gray-100 rounded-xl shadow-lg p-8 sm:p-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-black mb-6 text-center">
            Contact Us
          </h2>
          <p className="text-gray-600 dark:text-gray-800 mb-8 text-center">
            We'd love to hear from you! Please fill out the form below or reach
            us directly via email or phone.
          </p>

          {/* Contact Form */}
          <form className="space-y-6">
            {/* Email */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 dark:text-gray-900"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="you@example.com"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-400 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-white dark:text-black"
              />
            </div>

            {/* Phone Number */}
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 dark:text-gray-900"
              >
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                placeholder="+1 (555) 123-4567"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-400 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-white dark:text-black"
              />
            </div>

            {/* Message */}
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-700 dark:text-gray-900"
              >
                Message
              </label>
              <textarea
                id="message"
                rows={4}
                placeholder="Your message..."
                className="mt-1 block w-full px-4 py-2 border border-gray-300 dark:border-gray-400 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-white dark:text-black"
              />
            </div>

            {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                className="inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-white bg-blue-600 hover:bg-blue-700 rounded-md font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Send Message
              </button>
            </div>
          </form>

          {/* Direct Contact Info */}
          <div className="mt-10 border-t pt-6 text-center">
            <p className="text-gray-700 dark:text-gray-900">
              Or reach us directly:
            </p>
            <p className="mt-2 text-gray-900 dark:text-black font-medium">
              Email: info@honeconnect.com
            </p>
            <p className="text-gray-900 dark:text-black font-medium">
              Whatspp:
              <Link to="https://wa.me/+2349060102882">+2349060102882</Link>
            </p>
          </div>
        </div>
      </section>
      <WebsiteFooter />
    </main>
  );
};

export default ContactUs;
